import { currentSound, fadeOutAfter, play, setVolume, stop, type SoundId } from '../core/audio'
import { clear, h } from '../core/dom'
import { haptic } from '../core/haptics'
import { getSettings, markRitualDone, updateSettings } from '../core/store'
import { num, t } from '../i18n'
import { topbar } from './shared'

const TIMERS = [0, 15, 30, 45, 60, 90] as const

export function renderSound(root: HTMLElement): void {
  // Sound deliberately survives leaving this screen — people start it, put the
  // phone down and expect it to keep playing while they lie in the dark.
  let timerMinutes = 0

  const paint = (): void => {
    clear(root)
    const d = t()
    const active = currentSound()
    const volume = getSettings().soundVolume

    const options: Array<[SoundId, string, string]> = [
      ['brown', '▂', d.sound.brown],
      ['rain', '☂', d.sound.rain],
      ['drone', '◍', d.sound.drone],
      ['hush', '≈', d.sound.hush],
      ['heart', '♥', d.sound.heart],
    ]

    const volumeInput = h('input', {
      type: 'range',
      min: '0',
      max: '100',
      value: String(Math.round(volume * 100)),
      oninput: (e: Event) => {
        const v = Number((e.target as HTMLInputElement).value) / 100
        updateSettings({ soundVolume: v })
        setVolume(v)
      },
    })

    root.append(
      topbar(d.sound.title),
      h(
        'div',
        { class: 'stack fade-in' },
        h(
          'div',
          { class: 'stack-sm' },
          ...options.map(([id, glyph, label]) =>
            h(
              'button',
              {
                class: `tile ${active === id ? 'selected' : ''}`,
                onclick: () => {
                  haptic.tap()
                  if (currentSound() === id) {
                    stop()
                  } else {
                    void play(id, getSettings().soundVolume)
                    markRitualDone('sound')
                  }
                  paint()
                },
              },
              h('span', { class: 'glyph' }, glyph),
              h('span', { class: 'label grow' }, label),
              active === id && h('span', { class: 'sub' }, '●'),
            ),
          ),
        ),

        h('div', { class: 'divider' }),

        h(
          'div',
          { class: 'stack-sm' },
          h('label', { class: 'field' }, d.sound.volume),
          volumeInput,
        ),

        h(
          'div',
          { class: 'stack-sm' },
          h('label', { class: 'field' }, d.sound.timer),
          h(
            'div',
            { class: 'chips' },
            ...TIMERS.map((m) =>
              h(
                'button',
                {
                  class: `chip ${timerMinutes === m ? 'on' : ''}`,
                  onclick: () => {
                    haptic.tap()
                    timerMinutes = m
                    if (m > 0) fadeOutAfter(m)
                    else if (currentSound() !== 'off') void play(currentSound(), volume)
                    paint()
                  },
                },
                m === 0 ? d.sound.noTimer : `${num(m)} ${d.common.minutes}`,
              ),
            ),
          ),
        ),

        active !== 'off' &&
          h(
            'button',
            {
              class: 'btn ghost block',
              onclick: () => {
                haptic.tap()
                stop()
                paint()
              },
            },
            d.sound.off,
          ),
      ),
    )
  }

  paint()
}
